import { render, staticRenderFns } from "./MyGroups.vue?vue&type=template&id=17716e33&scoped=true&"
import script from "./MyGroups.vue?vue&type=script&lang=js&"
export * from "./MyGroups.vue?vue&type=script&lang=js&"
import style0 from "./MyGroups.vue?vue&type=style&index=0&id=17716e33&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17716e33",
  null
  
)

export default component.exports